import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import {
	Box,
	Dialog,
	DialogTitle,
	FormControl,
	Grid,
	TextField,
	Typography,
} from "@mui/material";

import MasterWeekViewPublic from "../DealMeetings/MasterWeekViewPublic";
import { ValidateEmail } from "../Common/helpers";

import LoadingButton from "@mui/lab/LoadingButton";
import { useCookies } from "react-cookie";

export default function SlotsDialog(props) {
	console.log("SlotsDialog", props);
	const [connex, setConnex] = useState(props.state.params.connex);
	const handleClose = () => {
		props.onClose();
	};

	const [values, setValues] = useState({
		email: "",
		password: "",
		fname: "",
		lname: "",
		email2: "",
	});
	const [cookies, setCookie] = useCookies();
	const [disabledSignIn, setDisabledSignIn] = useState(true);
	const [disabledSignUp, setDisabledSignUp] = useState(true);
	const [tkn, setTkn] = useState(undefined);
	useEffect(() => {
		if (ValidateEmail(values.email) && values.password !== "") {
			setDisabledSignIn(false);
		} else {
			setDisabledSignIn(true);
		}
		if (values.fname !== "" && values.lname != "" && ValidateEmail(values.email2)) {
			setDisabledSignUp(false);
		} else {
			setDisabledSignUp(true);
		}
	}, [values]);
	const submitSignin = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				email: values.email,
				password: values.password,
			}),
		};
		fetch("/anon/login", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setCookie("_bkeys", res.session_token, { path: "/" });
						setCookie("_bkuser", res.name, { path: "/" });
						setConnex(true);
						if (props.state.params.action === "B") {
							closeAndBookmark();
						}
						if (props.state.params.action === "A") {
						}
						break;
					case "err":
						setSnack({
							open: true,
							body: res.error_message,
							severity: "error",
						});
						break;
					default:
						break;
				}
			});
	};
	const submitSignup = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				lname: values.lname,
				fname: values.fname,
				email: values.email2,
				uid: props.state.params.id,
			}),
		};
		const url = props.state.params.action === "B" ? "/anon/signup/prbk" : "/anon/signup/pr";
		fetch(url, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				//console.log(res);
				switch (res.res) {
					case "ok":
						setCookie("_bkeys", res.session_token, { path: "/" });
						setCookie("_bkuser", res.name, { path: "/" });
						//window.location.href = "/publicpage/" + props.state.params.id + "?mode=A";
						setConnex(true);
						setTkn(res.tkn);
						break;

					case "err":
						setSnack({
							open: true,
							body: res.reason,
							severity: "error",
						});
						break;
					default:
						break;
				}
			});
	};

	const handleChange = (prop) => (event) => {
		setValues({ ...values, [prop]: event.target.value });
	};

	const [loadingState1, setLoadingState1] = useState(false);
	const [loadingState2, setLoadingState2] = useState(false);
	return (
		<Dialog onClose={handleClose} aria-labelledby="slots-dialog-title" open={props.state.opened}>
			<DialogTitle id="slots-dialog-title">
				<Typography variant="h5" style="">{!connex && `Vous n'êtes pas encore connecté`}
					{connex && `Les plages disponibles de rendez-vous`}</Typography>
			</DialogTitle>

			{!connex && (
				<div style="padding: 20px;">
					<Grid container spacing={2}>

						<Grid item xs={12}>
							<Typography variant="h5" style="margin: 10px;">
								J'ai un compte, je m'identifie
							</Typography>
							<Box display="flex" justifyContent="center" flexDirection="column">
								<FormControl variant="outlined" hiddenLabel>
									<TextField
										id="email"
										name="email"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Email"
										fullWidth
										margin="dense"
										size="small"
										value={values.email}
										onChange={handleChange("email")}
									/>
								</FormControl>
								<FormControl variant="outlined" hiddenLabel>
									<TextField
										id="password"
										name="password"
										type="password"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Mot de passe"
										fullWidth
										margin="dense"
										size="small"
										value={values.password}
										onChange={handleChange("password")}
									/>
								</FormControl>

								<LoadingButton
									loading={loadingState1} variant="contained" disabled={disabledSignIn} onClick={() => {
										setLoadingState1(true);
										setTimeout(() => {
											submitSignin();
										}, 750);
									}}>
									{props.state.params.action === "A" ? "Regarder les dispos" : "Fav**rise me , I'm famous"}
								</LoadingButton>
							</Box>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h5" style="margin: 10px;">
								Je n'ai pas encore de compte, je m'inscris
							</Typography>
							<Box display="flex" justifyContent="center" flexDirection="column">
								<FormControl variant="outlined" hiddenLabel>
									<TextField
										id="fname"
										name="fname"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Prénom"
										fullWidth
										margin="dense"
										size="small"
										value={values.fname}
										onChange={handleChange("fname")}
									/>
								</FormControl>

								<FormControl variant="outlined" hiddenLabel>
									<TextField
										id="lname"
										name="lname"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Nom"
										fullWidth
										margin="dense"
										size="small"
										value={values.lname}
										onChange={handleChange("lname")}
									/>
								</FormControl>
								<FormControl variant="outlined" hiddenLabel>
									<TextField
										id="email2"
										name="email2"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Email"
										fullWidth
										margin="dense"
										size="small"
										value={values.email2}
										onChange={handleChange("email2")}
									/>
								</FormControl>
								<LoadingButton
									loading={loadingState2} variant="contained" disabled={disabledSignUp} onClick={() => {
										setLoadingState2(true);
										setTimeout(() => {
											submitSignup();
										}, 750);
									}}>
									{props.state.params.action === "A" ? "Regarder les dispos" : "Fav**rise me , I'm famous"}
								</LoadingButton>
							</Box>
						</Grid>
					</Grid>
				</div>
			)}
			{connex && props.state.params.slots && props.state.params.slots.length === 0 && (
				<div style="height: 500px; width: 500px;">
					<Typography variant="h6" style="margin: 10px;">
						Oups, il n'y a pas de plages disponibles pour le moment, mais nous avons prévenu l'ambassadeur, il va vous recontacter
					</Typography>
					<div style="margin: 0 auto; height: 300px; width: 300px; background-size: contain; background-repeat: no-repeat; background-image: url('/images/sorry.png')" />
				</div>
			)}
			{connex && (
				<Grid container>
					<Grid item xs={12}>
						<MasterWeekViewPublic
							state={{ ...props.state, deal_uid: props.state.params.id, actualDeal: props.state.params.actualDeal, tkn: tkn }}
							setUpperState={props.state.params.setState}
							handleClose={handleClose} />
					</Grid>
				</Grid>
			)}
		</Dialog>
	);
}
